export default ({ hasNext, items }) => (index) =>
  !hasNext || index < items.length
